<template>
  <Card :padding="false">
    <template slot="header">Campgrounds</template>
    <v-btn
      color="primary"
      dark
      class="mb-2"
      @click="dialog=true"
    >
      Create
    </v-btn>
    <Modal
      :visible="map.visible"
      class="has-text-centered"
      @ok="map.visible=false"
    >
      <a
        :href="map.url"
        target="new">{{ map.url }}</a>
    </Modal>
    <Modal
      :visible="dialog"
      :ok-visible="true"
      :cancel-visible="true"
      ok-text="Save"
      title="Create"
      @ok="save"
      @cancel="close"
    >
      <v-text-field
        v-model="editedItem.campgroundName"
        label="Name"
        prepend-icon=""
      />
      <v-text-field
        v-model="editedItem.campgroundMap"
        label="Map"
        prepend-icon=""
      />
      <v-switch
        v-model="editedItem.adminOnly"
        true-value="1"
        false-value="0"
        label="Admin"
      />
    </Modal>
    <v-data-table
      :headers="headers"
      :items="campgrounds"
      hide-actions
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>
          {{ props.item.campgroundName }}
          <Icon
            v-if="props.item.adminOnly==='1'"
            set="fas"
            type="lock"/>
        </td>
        <td>
          <button
            v-if="props.item.campgroundMap"
            class="button"
            @click="map = { visible: true, url: props.item.campgroundMap }">
            <Icon
              set="fas"
              type="map"/>
          </button>
        </td>
        <td class="text-xs-right">
          <IconButton
            :to="{path: '/campgrounds/edit', query: campgrounds[props.index]}"
            icon="fa-eye"
            tooltip="View Campsites"
          />
          <IconButton
            icon="fa-edit"
            tooltip="Edit"
            @click="editItem(props.index)"
          />
          <IconButton
            icon="fa-times"
            color="red"
            tooltip="Delete"
            @click="deleteItem(props.index)"
          />
        </td>
      </template>
    </v-data-table>
  </Card>
</template>

<script>
// import vuex mapping
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    personGroup: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      dialog: false,
      map: {
        visible: false,
        url: ''
      },
      headers: [
        {
          text: 'Campground',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Map',
          sortable: false
        },
        {
          text: '',
          align: 'right',
          sortable: false
        }
      ],
      editedIndex: -1,
      editedItem: {}
    }
  },
  computed: {
    ...mapGetters({
      campgrounds: 'facilities/campgrounds',
      campsites: 'facilities/campsites'
    })
  },
  mounted () {
    this.getCampgrounds()
  },
  methods: {
    ...mapActions({
      getCampgrounds: 'facilities/getCampgrounds',
      createCampground: 'facilities/createCampground',
      updateCampground: 'facilities/updateCampground',
      deleteCampground: 'facilities/deleteCampground'
    }),
    editItem (index) {
      this.editedIndex = index
      this.editedItem = this.campgrounds[index]
      this.dialog = true
    },
    deleteItem (index) {
      let confirmation = confirm('Are you sure you want to delete this campground?')
      if (confirmation) {
        this.deleteCampground({ campgroundID: this.campgrounds[index].campgroundID })
      }
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex === -1) {
        this.createCampground(this.editedItem)
      } else {
        this.updateCampground(this.editedItem)
      }
      this.close()
    }
  }
}
</script>
